import { appLocalStorage } from '@/app/shared/commonURLs';

let PharmacyodataUrl = appLocalStorage.PharmacyodataUrl;
let VisitManagementUrl = appLocalStorage.VisitManagementUrl;
let VisitManagementODataUrl = appLocalStorage.VisitManagementODataUrl;
let ProductManagementODataUrl = appLocalStorage.ProductManagementODataUrl;
let CPOEUrl = appLocalStorage.CpoeUrl;
let BO_CPOEUrl = appLocalStorage.CPOEBackOfficeUrl;
//let CpoeODataUrl = appLocalStorage.CpoeODataUrl;
let BO_CpoeODataUrl = appLocalStorage.CPOEBackOfficeODataUrl;
let MedicalsetupUrl = appLocalStorage.MedicalsetupUrl;
let MedicalSetupODataServiceUrl = appLocalStorage.MedicalsetupOdataUrl;
let SupplyChainUrl = appLocalStorage.SupplyChainUrl;
let SecurityUrl = appLocalStorage.SecurityServiceUrl;
let PmgtServiceUrl = appLocalStorage.PmgtServiceUrl;
let BillingServiceUrl = appLocalStorage.BillingServiceUrl;
let HrOdataServiceUrl = appLocalStorage.HrOdataServiceUrl
let ProductManagementUrl = appLocalStorage.ProductManagementUrl;
export class PharmacyModuleURls {
    constructor() {
        this.pharmacyServicesList = PharmacyURls();
    }
}

const PharmacyURl = new PharmacyModuleURls();

export { PharmacyURl };

function PharmacyURls() {

    var services = {};
    services["InitIVPreparationFilteration"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'IVFluids/InitIVPreparationFilteration',
    }

    services["InitIVPreparationEditPopup"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'IVFluids/InitIVPreparationEditPopup',
    }

    services["InitIVEditPopup"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'IVFluids/InitIVEditPopup',
    }
    services["AppointmentDetailsOData"] = {
        Method: 'Get',
        URL: PharmacyodataUrl + 'AppointmentDetailsOData?'
    }

    services["InitFiltrationCriteriaLookUpsByClassification"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'Visit/InitVisitManagementScreenByClassification',
    }

    services["FilterClinicsData"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'Visit/FilterClinicInstancesAndTags',
    }

    services["GetDispsenseHistory"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'VisitList',
    }
    services["GetMedications"] = {
        Method: 'Get',
        URL: ProductManagementUrl + 'Product/GetMedications',
    }

    services["VisitReceiptsOData"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'VisitReceiptsOData',
    }

    services["SearchRecieptDetailsByParameters"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'ReceiptDetailsOData',
    }

    services["ViewReceiptItemsOData"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'ReceiptItemsOData',
    }

    services["InitPharmaciestVisitViewByCassification"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'Visit/InitPharmaciestVisitViewByCassification',
    };


    services["GetVisitServices"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetPharmacyVisitServices',
    };

    services["GetVisitServiceSearchResult"] = {
        Method: 'GET',
        URL: VisitManagementODataUrl + 'PharmacyVisitServiceSearchOData',
    };

    services["GetServiceSummeryFooter"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetPharmacyInpatientServiceFooterSummery'
    };

    services["InitDiscountPopup"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/InitPharmacyDiscountPopup',
    };

    services["GetEmployeeByCategory"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetPharmacyEmployeeByCategory'
    };

    services["EditServicesDiscount"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'VisitService/EditPharmacyServicesDiscount'
    };

    services["PaymentTransactions"] = {
        Method: 'GET',
        URL: VisitManagementODataUrl + 'PharmacyPaymentTransactionOData'
    };

    services["InitPharmacyPaymentPopup"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitServicePayment/InitPharmacyPaymentPopup'
    };

    services["GetPharmacyEmployeeList"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitServicePayment/GetPharmacyEmployeeList'
    };

    services["ConfirmPharmacyPaymentTransaction"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitServicePayment/PharmacyConfirmServicesPaymentTransaction'
    };

    services["GetBillingLKP"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetPharmacyBillingInsuranceLKP',
    };
    services["GetBillingContract"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetPharmacyBillingContracts',
    };
    services["GetBillingContractorClient"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetPharmacyBillingContractorClientsList',
    };
    services["EditVisitFinancialStatus"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/EditPharmacyVisitFinancialStatus',
    };

    services["GetInsuranceCardList"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetPharmacyInsuranceCardList',
    };
    services["deleteInsuranceCard"] = {
        Method: 'DELETE',
        URL: VisitManagementUrl + 'Visit/deletePharmacyInsuranceCard',
    };
    services["ValidateInsuredBillingData"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/ValidatePharmacyInsuredBillingData',
    };

    services["ChangeFinancialStateToCash"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Visit/PharmacyChangeFinancialStateToCash',
    };


    services["PreviewReceipt"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/PreviewReceipt',
    };

    services["InitPharmacyReceptionistAddService"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/InitPharmacyReceptionistAddService',
    };

    services["GetAvailablePharmacyBatches"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetAvailablePharmacyBatches',
    };

    services["GetPharmacyProductDetails"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetPharmacyProductDetails',
    };

    services["GetProductByClassification"] = {
        Method: 'GET',
        URL: ProductManagementODataUrl + 'ProductOData',
    };

    services["RePrice"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/RePriceByPharmacy',
    };

    services["InitPharmacyRefundPaymentPopup"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitServicePayment/InitPharmacyRefundPaymentPopup'
    };

    services["SavePharmacyCashRefundPaymentTransaction"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'VisitServicePayment/SavePharmacyCashRefundPaymentTransaction'
    };

    services["SavePharmacyCreditRefundPaymentTransaction"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'VisitServicePayment/SavePharmacyCreditRefundPaymentTransaction'
    };

    services["SavePharmacyDDRefundPaymentTransaction"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'VisitServicePayment/SavePharmacyDDRefundPaymentTransaction'
    };

    services["PharmacyRefundCashFromCreditPayment"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'VisitServicePayment/PharmacyRefundCashFromCreditPayment'
    };

    services["GetSourceOfBusinessData"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetPharmacySourceOfBusinessData',
    };

    services["UpdateSourceOfBusiness"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'PatientSourceOfBusiness/UpdatePharmacySourceOfBusiness'
    };

    services["RetrieveMedicationOL"] = {
        Method: 'GET',
        URL: BO_CpoeODataUrl + 'MedicationOrderLineOData'
    };
    services["RetrieveMedicationOLProducts"] = {
        Method: 'GET',
        URL: BO_CpoeODataUrl + 'RetrieveMedicationOLProductsOData'
    };

    services["InitPharmacistPrescriptionVisitView"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/InitPharmacistPrescriptionVisitView'
    };

    services["GetPatientFinancialInfoForPharmacy"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetPatientFinancialInfoForPharmacy'
    };

    services["GetAllPhysicians"] = {
        Method: 'GET',
        URL: MedicalsetupUrl + 'Physician/getPhysicians'
    };


    services["GetOrderLineStatusData"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetOrderLineStatusData'
    };

    services["GetServiceNoteByServiceID"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitServiceNote/GetPharmacyServiceNoteByServiceID',

    };

    services["AddServiceNote"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitServiceNote/AddPharmacyServiceNote'

    };

    services["DeletePrivateServiceNote"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitServiceNote/DeletePharmacyPrivateServiceNote'
    }

    services["GetPatientOrderlinesReceptionNotes"] = {
        Method: 'GET',
        URL: CPOEUrl + 'OrderLine/GetPatientOrderlinesReceptionNotes'
    };

    services["updateMedicationorderlinequantities"] = {
        Method: 'GET',
        URL: BO_CPOEUrl + 'MedicationOrderLine/updateMedicationorderlinequantities'
    };

    services["GetOrderEntryStaticLookup"] = {
        Method: 'GET',
        URL: CPOEUrl + 'OrderEntry/GetOrderEntryStaticLookup'
    };

    services["GetBarcodeDetail"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetProductDetailsByBarcode'
    };

    services["AddVisitNote"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Visit/AddPharmacyVisitNote'
    };

    services["InitCancelVisitPopup"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/InitCancelVisitPopup'
    };

    services["CancelVisit"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Visit/CancelVisit'
    };

    services["CancelPharmacyVisitService"] = {
        Method: 'DELETE',
        URL: VisitManagementUrl + 'VisitService/CancelPharmacyVisitService'
    };

    services["InitRevertDischargeVisitPopup"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/InitRevertDischargeVisitPopup'
    };

    services["ConfirmRevertDischargedVisit"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Visit/ConfirmRevertDischargedVisit'
    };

    services["GetEmployeeByCategory"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetEmployeeByCategory'
    };

    services["DischargeVisit"] = {
        Method: 'PUT',
        URL: VisitManagementUrl + 'Visit/DischargeVisit'
    };

    services["GetConvertedQuantityToSalesUOM"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SupplyChainProduct/GetConvertedQuantityToSalesUOM'
    };

    services["GetWarehouseLocation"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCLookUp/GetAssignedWarehousesLocationsForProduct'
    };

    services["GetAssignedWarehousesLocationsOfUser"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCLookUp/GetAssignedWarehousesLocations'
    };

    services["GetAvailableQty"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCWarehouseProductsBarcodes/GetAvailableQty'
    };

    //services["GetProductDetailsByBarcode"] = {
    //    Method: 'GET',
    //    URL: SupplyChainUrl + 'SupplyChainProduct/GetProductDetailsByBarcode'
    //};

    services["GetProductDetailsByBarcode"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/GetPharmacyProductDetailsByBarcode'
    };

    services["GetAllVisitSource"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetAllVisitSource',
    };

    services["GetUserDisplayNames"] = {
        Method: 'GET',
        URL: SecurityUrl + 'User/GetUserInfo',
    };

    services["GetBatchPricing"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitService/GetBatchPricing'
    };



    services["GetAlternatives"] = {
        Method: 'GET',
        URL: PmgtServiceUrl + 'Drug/GetAlternatives',
    };

    services["ChargeAndDispensItem"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitService/ChargeAndDispensItem'
    };
    services["ChargeItem"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitService/ChargeItem'
    };
    services["CreateVisitByPharmacist"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Visit/CreateVisitByPharmacist'
    };
    services["ConfirmPharamcyReturnNew"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitService/ConfirmPharamcyReturnNew'
    };
    services["ReturnByReceipt"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'ReturnVisitServiceByReceipt/ReturnByReceipt'
    };
    services["InitServiceDose"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/InitServiceDose'
    };
    services["SaveAndPrintServiceDose"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitService/SaveAndPrintServiceDose'
    };
    services["PharmacySetRequestDataForApproval"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Authorization/PharmacySetRequestDataForApproval'
    };
    services["GetPharmacyApprovalRequestsLKPs"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Authorization/GetPharmacyApprovalRequestsLKPs'
    };
    services["InitAddPharmacyApprovalRequests"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Authorization/InitAddPharmacyApprovalRequests'
    };
    services["AddClientToSpecificContractor"] = {
        Method: 'POST',
        URL: BillingServiceUrl + 'BillingLookup/AddClientToSpecificContractor',
    };
    services["PhysicianOData"] = {
        Method: 'GET',
        URL: MedicalSetupODataServiceUrl + 'GetPhysiciansOData'
    };

    services["MarkPharmcyServicesAsNeedsApproval"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitService/MarkPharmcyServicesAsNeedsApproval'
    };

    services["UndoMarkPharmcyServicesAsNeedsApproval"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitService/UndoMarkPharmcyServicesAsNeedsApproval'
    };

    services["PharmacyBulkInAssignCoverLetter"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/PharmacyBulkInAssignCoverLetter'
    };

    services["EditPharmacyVisitService"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitService/EditPharmacyVisitService'
    };

    services["PharmacyDownloadAttachment"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitAttachments/PharmacyDownloadAttachment'
    };

    services["PharmacyDownloadAttachmentForPrint"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitAttachments/PharmacyDownloadAttachmentForPrint'
    };

    services["InitOpenAttachmentPopup"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'VisitAttachments/InitPharmacyAddAttachmentPopup'
    }

    services["AssignPatientAttachmentToVisit"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitAttachments/PharmacyAssignPatientAttachmentToVisit'
    };

    services["InAssignPatientAttachmentToVisit"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitAttachments/PharmacyInAssignPatientAttachmentToVisit'
    };

    services["PharmacyDeleteAttachments"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitAttachments/PharmacyDeleteAttachments'
    };

    services["Savefiles"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'VisitAttachments/PharmacySaveNewAttachment'
    };

    services["InitReturnByReceiptGrid"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'ReturnVisitServiceByReceipt/InitReturnByReceiptGrid',
    };

    services["InitReturnByReceiptSearch"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'ReturnVisitServiceByReceipt/InitReturnByReceiptSearch',
    };

    services["RefundByReceipt"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'ReturnVisitServiceByReceipt/RefundByReceipt',
    };

    services["GetByOrderVisitCreationTypeConfiguration"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetByOrderVisitCreationTypeConfiguration',
    }

    services["GetMainSolutionsAndPhysicians"] = {
        Method: 'GET',
        URL: BO_CPOEUrl + 'MedicationOrderLine/GetMainSolutionsAndPhysicians'
    };
    services["GetIVMedicationOrderLines"] = {
        Method: 'GET',
        URL: CPOEUrl + 'MedicationOrderLine/GetIVMedicationOrderLines'
    };
    services["UpdateMainSolutionOrderline"] = {
        Method: 'GET',
        URL: CPOEUrl + 'MedicationOrderLine/UpdateMainSolutionOrderline'
    };

    services["CreateIVMedicationOrderline"] = {
        Method: 'post',
        URL: CPOEUrl + 'MedicationOrderLine/CreateIVMedicationOrderline'
    };
    services["EmployeesJobOdata"] = {
        Method: 'GET',
        URL: HrOdataServiceUrl + 'EmployeesJobOdata'
    };
    services["UpdateMainSolutionDetails"] = {
        Method: 'post',
        URL: CPOEUrl + 'UpdateMainSolutionDetails'
    };
    services["EditIVOrder"] = {
        Method: 'post',
        URL: VisitManagementUrl + 'IVFluids/EditIVOrder'
    };
    services["EditIVPreparation"] = {
        Method: 'post',
        URL: VisitManagementUrl + 'IVFluids/EditIVPreparation'
    };


    services["UpdateMainSolutionOrderline"] = {
        Method: 'post',
        URL: VisitManagementUrl + 'IVFluids/UpdateMainSolutionOrderline'
    };

    services["CreateIVMedicationOrderline"] = {
        Method: 'post',
        URL: VisitManagementUrl + 'IVFluids/CreateIVMedicationOrderline'
    };
    
    services["PrepareIVMedicationDose"] = {
        Method: 'post',
        URL: BO_CPOEUrl + 'MedicationOrderlineInstance/PrepareIVMedicationDose'
    };

    services["PrepareIVFluid"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'IVFluids/PrepareIVFluid'
    };
    services["InitOwnMedicationPopUp"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'OwnMedication/InitOwnMedicationPopUp'
    };

    services["GetProductUnitsOfMeasureWithReference"] = {
        Method: 'GET',
        URL: SupplyChainUrl + 'SupplyChainProduct/GetProductUnitsOfMeasureWithReference'
    };

    services["SaveVirtualWarehouseItem"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'OwnMedication/SaveVirtualWarehouseItem'
    };

    services["GetBatchAvailableQuantity"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'OwnMedication/GetBatchAvailableQuantity'
    };

    services["GetIVMedicationOrderineInstances"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'IVFluids/GetIVMedicationOrderineInstances'
    };

    services["GetIVMedicationOrderLines"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'IVFluids/GetIVMedicationOrderLines'
    };

    return services;
}